import { SEND_2_BANK_MANY_WITHDRAWALS } from '../../routes';
import customAxios from "../../customAxios";


const withdrawalSend2BankMany = async (withdrawalId: Array<string>): Promise<any> => {
  try {
    return (await customAxios.put(SEND_2_BANK_MANY_WITHDRAWALS, {withdrawalId})).data;
  } catch (error: unknown) {
    console.error({ SEND_2_BANK_MANY_WITHDRAWALS: error });
    return false;
  }
};

export default withdrawalSend2BankMany;
